import { axios, transformAxiosError } from "@/utils/axios.create";

export interface ExportValidationSlot {
  validationDate: string;
  validationTime: string;
  participantNotificationResponse: string;
  participantResponseTime: string;
  validationType: string;
  notificationSentDatetime: string;
  notificationOpenedDatetime: string;
  notificationRespondedDatetime: string;
  onDemand: string;
  validationStatus: string;
  formFactor: string;
  incentiveAmount: string;
  nonCarriageReason: string;
}

export interface ExportDataRow {
  participantId: string;
  enrollmentId: string;
  clientId: string;
  currentEnrolmentStatus: string;
  firstValidationDate: string | null;
  firstValidationOnDemand: string;
  validationStatus: string;
  naloxoneId: string;
  formFactor: string;
  incentiveAmount: number | null;
  validations: ExportValidationSlot[];
  outcomeMeasureWeek6?: ExportValidationSlot | null;
  outcomeMeasureWeek10?: ExportValidationSlot | null;
}

export function extractExportBody(data: unknown): ExportDataRow[] {
  if (Array.isArray(data)) return data;
  if (data == null || typeof data !== "object") return [];
  const obj = data as Record<string, unknown>;
  let body = obj.body;
  if (Array.isArray(body)) return body;
  if (typeof body === "string") {
    try {
      const parsed = JSON.parse(body) as Record<string, unknown>;
      body = parsed?.body;
      if (Array.isArray(body)) return body;
    } catch {
      // ignore
    }
  }
  const dataObj = obj.data;
  if (
    dataObj != null &&
    typeof dataObj === "object" &&
    Array.isArray((dataObj as Record<string, unknown>).body)
  ) {
    return (dataObj as Record<string, ExportDataRow[]>).body;
  }
  return [];
}

const getExportData = async (programId: string): Promise<ExportDataRow[]> => {
  return axios
    .get("/enrollments/export-data", { params: { programId } })
    .then((res) => extractExportBody(res.data))
    .catch((err) => Promise.reject(transformAxiosError(err)));
};

export const ExportDataService = {
  getExportData,
  extractExportBody,
};
